/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Circle, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function GearSix(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256.00098 256.00098"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Circle
        cx={128.00195}
        cy={128.00195}
        r={48}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={8}
      />
      <Path
        d="M197.40724,80.65057a83.91052,83.91052,0,0,1,6.28743,10.91L229.641,105.964a103.88962,103.88962,0,0,1,.03182,44.05764L203.7121,164.433a83.91318,83.91318,0,0,1-6.30466,10.90011l.49943,29.67182a103.88959,103.88959,0,0,1-38.13912,22.05638l-25.46094-15.27692a83.91075,83.91075,0,0,1-12.5921-.01L96.26788,227.04288a103.88971,103.88971,0,0,1-38.171-22.00126l.49974-29.68828a83.91174,83.91174,0,0,1-6.28744-10.91005L26.363,150.0399a103.88962,103.88962,0,0,1-.03183-44.05764L52.29181,91.5709a83.91125,83.91125,0,0,1,6.30466-10.9001L58.097,50.999A103.88973,103.88973,0,0,1,96.23616,28.94259l25.46093,15.27693a83.91075,83.91075,0,0,1,12.5921.00995L159.736,28.961a103.88951,103.88951,0,0,1,38.171,22.00126Z"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={8}
      />
    </Svg>
  );
}

export default GearSix;
